import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Popup from "./Popup";
import "../../src/Dashboard.css";
import { Layout, Breadcrumb, Card, Row, Col, Button } from "antd";
import {
  getattendancereportlist,
  getCurriculamProgress,
  getvacantreportlist,
  getGuestLecturereportlist,
  getIndustrialVisitreportlist,
  getInvoicereportlist,
  getMoureportlist,
  getImportantUpdates,
  getSalaryReport,
} from "../features/dashboard/dashboardSlice";
import { getInvoiceReceiptInfo } from "../features/payments/paymentSlice";
import { getUsers } from "../features/students/studentSlice";
import { useNavigate } from "react-router-dom";
import SkeletonLoader from "../components/SkeletonLoader/Index";
import AttendanceLayout from "../popups/AttendanceLayout";
import CurriculamStatus from "../popups/CurriculamStatus";
import VacantPosition from "../popups/VacantPostion";
import MouStatus from "../popups/MouStatus";
// import Compliance from "../popups/Compliance";

const { Content, Footer } = Layout;

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [role, setRole] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchData = () => {
    dispatch(getattendancereportlist());
    dispatch(getvacantreportlist());
    dispatch(getCurriculamProgress());
    dispatch(getGuestLecturereportlist());
    dispatch(getIndustrialVisitreportlist());
    dispatch(getInvoicereportlist());
    dispatch(getMoureportlist());
    dispatch(getImportantUpdates());
    dispatch(getUsers());
    dispatch(getSalaryReport());
    dispatch(getInvoiceReceiptInfo()); // Dispatch to fetch invoiceReceiptInfo
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const attendancereportState = useSelector(
    (state) => state.dashboard.attendancereportlists
  );
  const vacantreportState = useSelector(
    (state) => state.dashboard.vacantreportlists
  );
  const curriculamprogressState = useSelector(
    (state) => state.dashboard.CurriculamProgresslist
  );
  const guestlectreportState = useSelector(
    (state) => state.dashboard.guestlecturereportlists
  );
  const industryvisireportState = useSelector(
    (state) => state.dashboard.industrialvisitreportlists
  );
  const invoicereportState = useSelector(
    (state) => state.dashboard.invoicereportlists
  );
  const moureportState = useSelector((state) => state.dashboard.moureportlists);
  const pendingInvoiceState = useSelector(
    (state) => state.dashboard.importantupdatelists
  );
  const studentState = useSelector((state) => state.student.students);
  const salaryReportState = useSelector(
    (state) => state.dashboard.SalaryReportlist
  );
  const assessmentOverviewState = useSelector(
    (state) => state?.assesmentlist?.assessmentOverviewlists || []
  );
  const placementReportState = useSelector(
    (state) => state?.placementList?.placementreportList || 0
  );
  const invoiceReceiptInfo = useSelector(
    (state) => state.payment.invoiceReceiptInfo
  ); // Access invoiceReceiptInfo

  const [attendanceDataVCVT, setAttendanceDataVCVT] = useState([]);
  const [vacantDataVC, setVacantDataVC] = useState([]);
  const [vacantDataVT, setVacantDataVT] = useState([]);
  const [guestLecturesData, setguestLecturesData] = useState([]);
  const [industrialVisitsData, setindustrialVisitsData] = useState([]);
  const [mouexpireData, setmouexpireData] = useState([]);
  const [curriculamProgressData, setcurriculamProgressData] = useState(null);
  const [totalPendingInvoiceAmount, settotalPendingInvoiceAmount] = useState();
  const [student, setStudent] = useState("");
  const [pendingSalary, setPendingSalary] = useState("");
  const [assessmentOverviewData, setAssessmentOverviewData] = useState([]);
  const [excessReceiptPercent, setExcessReceiptPercent] = useState("0%"); // State for Excess Receipt %

  const [isPopupOpen, setIsPopupOpen] = useState({
    isAttendancePopupOpen: false,
    isCurriculumPopupOpen: false,
    isVacantPopupOpen: false,
    isMouStatusPopupOpen: false,
    isCompilanceStatusPopupOpen: false,
    isCompliancePopupOpen: false,
  });

  const openPopup = (popupName) => {
    setIsPopupOpen((prev) => ({ ...prev, [popupName]: true }));
  };

  const closePopup = (popupName) => {
    setIsPopupOpen((prev) => ({ ...prev, [popupName]: false }));
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role")
      ? JSON.parse(localStorage.getItem("role"))
      : null;
    setRole(storedRole);
  }, []);

  useEffect(() => {
    // Calculate Excess Receipt % on Salary Paid
    if (invoiceReceiptInfo?.data?.length > 0) {
      const totalSalaryPaid = invoiceReceiptInfo.data.reduce(
        (sum, item) => sum + (item.total_salary_paid || 0),
        0
      );
      const totalExcessReceipt = invoiceReceiptInfo.data.reduce(
        (sum, item) =>
          sum +
          ((item.total_payment_received || 0) +
            (item.tds_deducted || item.total_tds || 0) -
            (item.total_salary_paid || 0)),
        0
      );
      const percentage = totalSalaryPaid
        ? `${Math.round((totalExcessReceipt / totalSalaryPaid) * 100)}%`
        : "0%";
      setExcessReceiptPercent(percentage);
    } else {
      setExcessReceiptPercent("0%");
    }

    // Existing useEffect logic
    if (attendancereportState && attendancereportState.data) {
      const vcvtPresent =
        attendancereportState.data.summary.presentPercentage || 0;
      const vcvtAbsent =
        attendancereportState.data.summary.absentPercentage || 0;

      setAttendanceDataVCVT([
        { name: "Present", value: vcvtPresent },
        { name: "Absent", value: vcvtAbsent },
      ]);
    }
    if (curriculamprogressState) {
      const avgProgress = curriculamprogressState.length > 0
        ? curriculamprogressState.reduce((sum, item) => sum + (item?.progress || 0), 0) / curriculamprogressState.length
        : 0;

      setcurriculamProgressData(Number(avgProgress).toFixed(0));
    }
    if (vacantreportState) {
      const totalVTWorking = vacantreportState?.totalVTWorking || 0;
      const totalVTVacant = vacantreportState?.totalVTVacant || 0;
      const totalVCWorking = vacantreportState?.totalVCWorking || 0;
      const totalVCVacant = vacantreportState?.totalVCVacant || 0;

      const totalVT = totalVTWorking + totalVTVacant || 1;
      const totalVC = totalVCWorking + totalVCVacant || 1;

      const vtWorkingPercentage =
        totalVT > 0 ? ((totalVTWorking / totalVT) * 100).toFixed(1) : 0;
      const vtVacantPercentage =
        totalVT > 0 ? ((totalVTVacant / totalVT) * 100).toFixed(1) : 0;

      const vcWorkingPercentage =
        totalVC > 0 ? ((totalVCWorking / totalVC) * 100).toFixed(1) : 0;
      const vcVacantPercentage =
        totalVC > 0 ? ((totalVCVacant / totalVC) * 100).toFixed(1) : 0;

      setVacantDataVT([
        { name: "Working", value: vtWorkingPercentage },
        { name: "Vacant", value: vtVacantPercentage },
      ]);

      setVacantDataVC([
        { name: "Working", value: vcWorkingPercentage },
        { name: "Vacant", value: vcVacantPercentage },
      ]);
    }
    if (guestlectreportState && guestlectreportState?.data) {
      const totalComplete = guestlectreportState?.data?.done || 0;
      const totalPending = guestlectreportState?.data?.pending || 0;

      setguestLecturesData([
        { name: "Done", value: totalComplete },
        { name: "Pending", value: totalPending },
      ]);
    }
    if (industryvisireportState && industryvisireportState?.data) {
      const totalComplete = industryvisireportState?.data?.done || 0;
      const totalPending = industryvisireportState?.data?.pending || 0;

      setindustrialVisitsData([
        { name: "Done", value: totalComplete },
        { name: "Pending", value: totalPending },
      ]);
    }
    if (moureportState && moureportState?.data) {
      const totalexpired = moureportState?.data?.expired || 0;
      const totalRunning = moureportState?.data?.pending || 0;

      setmouexpireData([
        { name: "Expired", value: totalexpired },
        { name: "Running", value: totalRunning },
      ]);
    }
    if (pendingInvoiceState && pendingInvoiceState?.data) {
      const pendingInvoiceData =
        pendingInvoiceState?.data?.totalInvoicesAmount -
          pendingInvoiceState?.data?.totalReceivedInvoicesAmount || 0;
      settotalPendingInvoiceAmount(pendingInvoiceData);
    }
    if (studentState) {
      setStudent(studentState.length);
    }
    if (salaryReportState) {
      setPendingSalary(salaryReportState?.pendingSalarycount);
    }
    if (assessmentOverviewState) {
      const totalPassed = assessmentOverviewState?.pass || 0;
      const totalFailed = assessmentOverviewState?.fail || 0;

      setAssessmentOverviewData([
        { name: "Pass", value: totalPassed },
        { name: "Fail", value: totalFailed },
      ]);
    }
  }, [
    attendancereportState,
    curriculamprogressState,
    vacantreportState,
    guestlectreportState,
    industryvisireportState,
    invoicereportState,
    moureportState,
    pendingInvoiceState,
    studentState,
    salaryReportState,
    assessmentOverviewState,
    invoiceReceiptInfo, // Add to dependency array
  ]);

  if (role === "hr" || role === "accountant") {
    return (
      <Layout style={{ backgroundColor: "#eaedf2", minHeight: "100vh", fontFamily: "Poppins, sans-serif" }}>
        <Content style={{ padding: isMobile ? "12px" : "24px 50px", backgroundColor: "#eaedf2" }}>
          <Breadcrumb
            style={{ margin: "16px 0" }}
            items={[{ title: "Home" }, { title: "Dashboard" }]}
          />
          <div className="site-layout-content" style={{ width: "100%" }}>
            <Row justify="center" style={{ marginTop: 50 }}>
              <Col xs={24} sm={16} md={12}>
                <Card className="cardStyle" bordered={false} style={{ padding: "20px" }}>
                  <h2 style={{ color: "#1a2332", fontWeight: "700", marginBottom: "12px" }}>Welcome to the Dashboard</h2>
                  <p style={{ color: "#64748b", fontSize: "14px", lineHeight: "1.6", marginBottom: "20px" }}>
                    As an <strong>{role.toUpperCase()}</strong>, you can view
                    your relevant sections using the menu on the left.
                  </p>
                  <Button 
                    type="primary"
                    style={{
                      background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                      border: "none",
                      borderRadius: "6px",
                      boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                      height: "38px",
                      fontWeight: "500",
                    }}
                  >
                    Explore More
                  </Button>
                </Card>
              </Col>
            </Row>
          </div>
        </Content>
        <Footer style={{ textAlign: "center", backgroundColor: "#eaedf2", color: "#64748b" }}>
          Admin Dashboard ©2024 Developed by LNJ
        </Footer>
      </Layout>
    );
  }

  return (
    <Layout style={{ backgroundColor: "#eaedf2", minHeight: "100vh", fontFamily: "Poppins, sans-serif" }}>
      <Content style={{ padding: isMobile ? "12px" : "24px 50px", backgroundColor: "#eaedf2" }}>
        <Breadcrumb
          style={{ margin: "16px 0" }}
          items={[{ title: "Home" }, { title: "Dashboard" }]}
        />
        <div className="site-layout-content" style={{ width: "100%" }}>
          
          {/* Daily Overview */}
          <Row className="row" gutter={[16, 16]}>
            <Col span={24}>
              <h5 className="col-Heading">Daily Overview</h5>
            </Col>
            
            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                {attendanceDataVCVT?.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                      <span style={{ fontSize: "20px" }}>📅</span>
                      <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Attendance</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                      <span style={{ color: "#64748b" }}>Present:</span>
                      <span className="text-green">{attendanceDataVCVT[0]?.value || 0}%</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                      <span style={{ color: "#64748b" }}>Absent:</span>
                      <span className="text-red">{attendanceDataVCVT[1]?.value || 0}%</span>
                    </div>
                  </div>
                ) : (
                  <SkeletonLoader count={3} />
                )}
                <Button
                  type="primary"
                  onClick={() => openPopup("isAttendancePopupOpen")}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    border: "none",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                    marginTop: "14px",
                    width: "100%",
                    height: "36px",
                    fontWeight: "500",
                  }}
                >
                  View Details
                </Button>
                <Popup
                  isOpen={isPopupOpen.isAttendancePopupOpen}
                  onClose={() => closePopup("isAttendancePopupOpen")}
                >
                  <AttendanceLayout />
                </Popup>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                {curriculamProgressData !== null ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                      <span style={{ fontSize: "20px" }}>📚</span>
                      <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Curriculum Progress</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                      <span style={{ color: "#64748b" }}>Status:</span>
                      <span className="text-green">{curriculamProgressData}% Completed</span>
                    </div>
                    <div style={{ height: "19px" }}></div>
                  </div>
                ) : (
                  <SkeletonLoader count={2} />
                )}
                <Button
                  type="primary"
                  onClick={() => openPopup("isCurriculumPopupOpen")}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    border: "none",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                    marginTop: "14px",
                    width: "100%",
                    height: "36px",
                    fontWeight: "500",
                  }}
                >
                  View Details
                </Button>
                <Popup
                  isOpen={isPopupOpen.isCurriculumPopupOpen}
                  onClose={() => closePopup("isCurriculumPopupOpen")}
                >
                  <CurriculamStatus />
                </Popup>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                {vacantDataVT?.length > 0 && vacantDataVC?.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                      <span style={{ fontSize: "20px" }}>👥</span>
                      <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Vacant Positions</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                      <span style={{ color: "#64748b" }}>Working VT:</span>
                      <span className="text-green">{vacantDataVT[0]?.value || 0}%</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                      <span style={{ color: "#64748b" }}>Vacant VT:</span>
                      <span className="text-red">{vacantDataVT[1]?.value || 0}%</span>
                    </div>
                  </div>
                ) : (
                  <SkeletonLoader count={3} />
                )}
                <Button
                  type="primary"
                  onClick={() => openPopup("isVacantPopupOpen")}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    border: "none",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                    marginTop: "14px",
                    width: "100%",
                    height: "36px",
                    fontWeight: "500",
                  }}
                >
                  View Details
                </Button>
                <Popup
                  isOpen={isPopupOpen.isVacantPopupOpen}
                  onClose={() => closePopup("isVacantPopupOpen")}
                >
                  <VacantPosition />
                </Popup>
              </Card>
            </Col>
          </Row>

          {/* Finance Dashboard */}
          <Row gutter={[16, 16]} className="row">
            <Col span={24}>
              <h5 className="col-Heading">Finance Dashboard</h5>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                {totalPendingInvoiceAmount > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                      <span style={{ fontSize: "20px" }}>💳</span>
                      <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Invoice/Receipt</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                      <span style={{ color: "#64748b" }}>Pending Amount:</span>
                      <span className="text-green">
                        ₹{Math.floor(totalPendingInvoiceAmount || 0).toLocaleString("en-IN")}
                      </span>
                    </div>
                    <div style={{ height: "19px" }}></div>
                  </div>
                ) : (
                  <SkeletonLoader count={2} />
                )}
                <Button
                  type="primary"
                  onClick={() => navigate("/admin/invoice-receipt")}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    border: "none",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                    marginTop: "14px",
                    width: "100%",
                    height: "36px",
                    fontWeight: "500",
                  }}
                >
                  Visit Dashboard
                </Button>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                {parseFloat(pendingSalary) > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                      <span style={{ fontSize: "20px" }}>💵</span>
                      <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Salary Payment</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                      <span style={{ color: "#64748b" }}>Pending Salary:</span>
                      <span className="text-red">₹{pendingSalary} Pending</span>
                    </div>
                    <div style={{ height: "19px" }}></div>
                  </div>
                ) : (
                  <SkeletonLoader count={2} />
                )}
                <Button
                  type="primary"
                  onClick={() => navigate("/admin/salary-payment")}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    border: "none",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                    marginTop: "14px",
                    width: "100%",
                    height: "36px",
                    fontWeight: "500",
                  }}
                >
                  Visit Dashboard
                </Button>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "20px" }}>📈</span>
                    <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Payment vs Receipt</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Profit Percent:</span>
                    <span className="text-green">{excessReceiptPercent}</span>
                  </div>
                  <div style={{ height: "19px" }}></div>
                </div>
                <Button
                  type="primary"
                  onClick={() => navigate("/admin/payment-vs-receipt")}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    border: "none",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                    marginTop: "14px",
                    width: "100%",
                    height: "36px",
                    fontWeight: "500",
                  }}
                >
                  View Details
                </Button>
              </Card>
            </Col>
          </Row>

          {/* Weekly Overview */}
          <Row gutter={[16, 16]} className="row">
            <Col span={24}>
              <h5 className="col-Heading">Weekly Overview</h5>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                {vacantDataVC?.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                      <span style={{ fontSize: "20px" }}>🏅</span>
                      <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>VC Performance</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                      <span style={{ color: "#64748b" }}>Performance:</span>
                      <span className="text-green">{vacantDataVC[0]?.value || 0}%</span>
                    </div>
                    <div style={{ height: "19px" }}></div>
                  </div>
                ) : (
                  <SkeletonLoader count={2} />
                )}
                <Button
                  type="primary"
                  onClick={() => navigate("/admin/vc-performance")}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    border: "none",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                    marginTop: "14px",
                    width: "100%",
                    height: "36px",
                    fontWeight: "500",
                  }}
                >
                  Visit Dashboard
                </Button>
              </Card>
            </Col>
          </Row>

          {/* Monthly Overview */}
          <Row gutter={[16, 16]} className="row">
            <Col span={24}>
              <h5 className="col-Heading">Monthly Overview</h5>
            </Col>
            
            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "20px" }}>🤝</span>
                    <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>MOU Expiring</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Expired:</span>
                    <span className="text-red">{mouexpireData[0]?.value || 0}</span>
                  </div>
                  <div style={{ height: "19px" }}></div>
                </div>
                <Button
                  type="primary"
                  onClick={() => openPopup("isMouStatusPopupOpen")}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    border: "none",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                    marginTop: "14px",
                    width: "100%",
                    height: "36px",
                    fontWeight: "500",
                  }}
                >
                  View Details
                </Button>
                <Popup
                  isOpen={isPopupOpen.isMouStatusPopupOpen}
                  onClose={() => closePopup("isMouStatusPopupOpen")}
                >
                  <MouStatus />
                </Popup>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "20px" }}>✓</span>
                    <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Compliance Status</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Status:</span>
                    <span className="text-red">Pending</span>
                  </div>
                  <div style={{ height: "19px" }}></div>
                </div>
                <Button
                  type="primary"
                  onClick={() => navigate("/admin/attendance")}
                  style={{
                    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                    border: "none",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(59, 130, 246, 0.3)",
                    marginTop: "14px",
                    width: "100%",
                    height: "36px",
                    fontWeight: "500",
                  }}
                >
                  View Details
                </Button>
              </Card>
            </Col>
          </Row>

          {/* General Overview */}
          <Row gutter={[16, 16]} className="row">
            <Col span={24}>
              <h5 className="col-Heading">General Overview</h5>
            </Col>
            
            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "20px" }}>🎓</span>
                    <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Student Trained</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Total Trained:</span>
                    <span className="text-green">{student || 0}</span>
                  </div>
                  <div style={{ height: "19px" }}></div>
                </div>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "20px" }}>👤</span>
                    <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Guest Lectures</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Planned:</span>
                    <span className="text-green">{guestLecturesData[0]?.value || 0}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Actual:</span>
                    <span className="text-red">{guestLecturesData[1]?.value || 0}</span>
                  </div>
                </div>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "20px" }}>🚌</span>
                    <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Industrial Visits</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Planned:</span>
                    <span className="text-green">{industrialVisitsData[0]?.value || 0}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Actual:</span>
                    <span className="text-red">{industrialVisitsData[1]?.value || 0}</span>
                  </div>
                </div>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "20px" }}>📝</span>
                    <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Assessment Status</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Planned:</span>
                    <span className="text-green">
                      {assessmentOverviewData[0]?.value + assessmentOverviewData[1]?.value || 0}
                    </span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Done:</span>
                    <span className="text-red">{assessmentOverviewData[0]?.value || 0}</span>
                  </div>
                </div>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card className="card" bordered={false}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "20px" }}>💼</span>
                    <span style={{ fontWeight: "600", fontSize: "15px", color: "#1a2332" }}>Placement Status</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Planned:</span>
                    <span className="text-green">
                      {placementReportState?.placed + placementReportState?.notPlaced || 0}
                    </span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                    <span style={{ color: "#64748b" }}>Done:</span>
                    <span className="text-red">{placementReportState?.placed || 0}</span>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </Content>
      <Footer style={{ textAlign: "center", backgroundColor: "#eaedf2", color: "#64748b" }}>
        Admin Dashboard ©2024 Developed by LNJ
      </Footer>
    </Layout>
  );
};

export default Dashboard;
